import _ from 'lodash';

export const getYears = (prevDif, nextDif) => {
    const years = [];
    const today = new Date();
    const nowYear = today.getFullYear();

    const firstYear = Number(nowYear) - Number(prevDif);
    const lastYear = Number(nowYear) + Number(nextDif);

    for (let index = firstYear; index <= lastYear; index++) {
        years.push(index);
    }

    return years;
}

export const getHeadquarterGoalsMonths = (headquarters) => {
    let goalsData = [];
    headquarters.forEach(headquarter => {
        let data = { id: headquarter.id, dptNm: headquarter.name };
        for (let index = 1; index < 13; index++) {
            let goal = Math.floor(Math.random() * 1000);
            data[index] = goal;
        };

        goalsData.push(data);
    });


    return goalsData;
}


export const getHeadquarterMonthsData = (headquarters) => {
    let rows = [];

    headquarters.forEach(headquarter => {

        let data = { id: headquarter.id, dptNm: headquarter.name, results: [], goals: [] };
        for (let index = 1; index < 13; index++) {
            let goal = Math.floor(Math.random() * 1000);
            data.goals.push({ [index]: goal })

            let result = Math.floor(Math.random() * 1000);
            data.results.push({ [index]: result })
        };
        rows.push(data);

    });


    return rows;
}



export const getHeadquarterQuarterData = (headquarters) => {
    let rows = [];

    headquarters.forEach(headquarter => {

        let data = { id: headquarter.id, dptNm: headquarter.name, results: [], goals: [] };
        for (let index = 1; index < 5; index++) {
            let goal = Math.floor(Math.random() * 1000);
            data.goals.push({ [index]: goal })

            let result = Math.floor(Math.random() * 1000);
            data.results.push({ [index]: result })
        };
        rows.push(data);

    });
    return rows;
}


export const getHeadquarterMonthsChart = (data) => {
    let chartData = [];

    for (let index = 0; index < 12; index++) {
        let object = { name: index + 1 + "월" };
        object['goal'] = data.goals[index][index + 1];
        object['result'] = data.results[index][index + 1];

        chartData.push(object)
    }
    return chartData;
}



export const getHeadquarterQuartersChart = (data) => {
    let chartData = [];

    for (let index = 0; index < 4; index++) {
        let object = { name: index + 1 + "분기" };
        object['goal'] = data.goals[index][index + 1];
        object['result'] = data.results[index][index + 1];

        chartData.push(object)
    }
    return chartData;
}

export const getQuarters = () => {
    const quarters = [];
    for (let index = 1; index < 5; index++) {
        quarters.push(index);
    };
    return quarters;
}

export const getMonths = () => {
    const months = [];
    for (let index = 1; index < 13; index++) {
        months.push(index);
    };
    return months;
}


export const getHeadquarterMonthsSalesData = (headquarters) => {
    let rows = [];

    headquarters.forEach(headquarter => {

        let data = { id: headquarter.id, dptNm: headquarter.name, chances: [], estimates: [], orders: [] };
        for (let index = 1; index < 13; index++) {
            let chance = Math.floor(Math.random() * 100);
            data.chances.push({ [index]: chance });

            let estimate = Math.floor(Math.random() * 100);
            data.estimates.push({ [index]: estimate });

            let order = Math.floor(Math.random() * 100);
            data.orders.push({ [index]: order })
        };
        rows.push(data);

    });


    return rows;
};

export const getHeadquarterMonthsSalesChart = (data) => {
    let chartData = [];

    for (let index = 0; index < 12; index++) {
        let object = { name: index + 1 + "월" };
        object['chance'] = data.chances[index][index + 1];
        object['estimate'] = data.estimates[index][index + 1];
        object['order'] = data.orders[index][index + 1];

        chartData.push(object)
    }
    return chartData;
}

export const getHeadquarterQuarterSalesData = (headquarters) => {
    let rows = [];

    headquarters.forEach(headquarter => {

        let data = { id: headquarter.id, dptNm: headquarter.name, chances: [], estimates: [], orders: [] };
        for (let index = 1; index < 5; index++) {
            let chance = Math.floor(Math.random() * 100);
            data.chances.push({ [index]: chance })

            let estimate = Math.floor(Math.random() * 100);
            data.estimates.push({ [index]: estimate })

            let order = Math.floor(Math.random() * 100);
            data.orders.push({ [index]: order })
        };
        rows.push(data);

    });
    return rows;
}

export const getHeadquarterQuartersSalesChart = (data) => {
    let chartData = [];

    for (let index = 0; index < 4; index++) {
        let object = { name: index + 1 + "분기" };
        object['chance'] = data.chances[index][index + 1];
        object['estimate'] = data.estimates[index][index + 1];
        object['order'] = data.orders[index][index + 1];

        chartData.push(object)
    }
    return chartData;
}

export const initGoalData = () => {
    let months = [];
    for (let index = 0; index < 12; index++) {
        let newObject = { month: index + 1, ptargetSales: '', ptargetSalesProfit: '', mtargetSales: '', mtargetSalesProfit: '' };
        months.push(newObject);
    }
    return months;
}

export const initPrjGoalData = () => {
    let months = [];
    for (let index = 0; index < 12; index++) {
        let newObject = { month: index + 1, ptargetSales: '', ptargetSalesProfit: '' };
        months.push(newObject);
    }
    return months;
};

export const monthPercent = [
    5,
    5,
    5,
    5,
    5,
    15,
    5,
    10,
    10,
    10,
    10,
    15
];

